import { IHomeState, IItem } from './home';

const mutations = {
    SET_LIST_ITEM(state: IHomeState, listItems: IItem[]) {
        state.listItems = listItems;
    },
    SET_RECALL_API(state: IHomeState, status: boolean) {
        state.reCallApi = status;
    },
    SET_COUNT_NFT(state: IHomeState, countNtf: any) {
        state.countNtf = countNtf;
    },
    SET_EXPIRED_BUY_NFT(state: IHomeState, expiredTimeBuy: any) {
        state.expiredTimeBuy = expiredTimeBuy;
    },
    SET_LIST_MY_COLLECTION_NOT_MINT(state: IHomeState, listCollectionsNotMint: any) {
        state.listCollectionsNotMint = listCollectionsNotMint;
    },
    SET_LIST_MY_COLLECTION(state: IHomeState, listCollectionsNotMint: any) {
        state.listCollectionsNotMint = listCollectionsNotMint;
    },
    SET_LIST_MY_COLLECTION_MINTED(state: IHomeState, listCollectionsMinted: any) {
        state.listCollectionsMinted = listCollectionsMinted;
    },
    SET_LIST_TOKEN_SELL(state: IHomeState, listTokenSell: any) {
        state.listTokenSell = listTokenSell.tokens;
        state.feeSell = listTokenSell.feeSell;
    },
};

export default mutations;
